;import $ from 'jquery';
window.$ = window.jQuery = $;
import "bootstrap";
import "jquery.scrollto";
import "../vendor/lightgallery-all.min.js";
import "../vendor/ba-debug.min.js";
import "../vendor/cookieconsent.min.js";

(function($){
//------------------------------------------------------------------------------------------------------------------------
    // (1) Oldal konstruktor

    // Oldal konstruktor
    window.Page = {

//------------------------------------------------------------------------------------------------------------------------
    // (2) Globalis valtozok

        // GTM
        dataLayer: window.dataLayer || [],

        // CSRF
        csrf_token: $('meta[name="csrf-token"]').attr('content'),

        // Reszponziv meretek
        mobileMaxWidth: 1199.98,
        smallDesktopMaxWidth: 1499.98,

        // scrollTo
        scrollTo: {
            axis: 'y',
            duration: 500,
            offset: {
                left: 0,
                top: -132 // dummy
            }
        },

        // lightGallery
        lightGallery: {
            autoplay: false,
            autoplayControls: false,
            counter: false,
            download: false,
            dynamic: true,
            fullScreen: false,
            hash: false,
            pager: false,
            rotate: false,
            share: false,
            thumbnail: false,
            zoom: true
        },

        // Cookie
        cookie: {
            palette: {
                popup: {
                    background: '#e5e5e5',
                    text: '#676767'
                }
            },
            content: {
                message: 'This website uses cookies to optimize the user experience - you acknowledge this by visiting the present site.',
                dismiss: 'Accept',
                link: 'More information',
                href: 'https://ophrysiricolor.com/privacy-policy/'
            }
        },

        // Modal
        modal: {
            message: false,
            title: false
        },

        // Tooltip
        tooltip: {
            container: 'body'
        },

        // Animation
        animation: 300,

//------------------------------------------------------------------------------------------------------------------------
    // (3) Layout atmeretezese

        // Layout atmeretezese
        resizeLayout: function(){
            // Sticky menu
            window.Page.stickyHeader();
        },

//------------------------------------------------------------------------------------------------------------------------
    // (4) Kapcsolat urlapok

        // Kapcsolat urlapok inicializalasa
        loadForms: function(){
            // CTA
            $(document).on('submit', '.modal-contact form', function(e){
                e.preventDefault();
                window.Page.sendForm($(this));
            });
        },

        // Kapcsolat urlapok bekuldese
        sendForm: function($target){
            // Loading
            $target.find('button[type="submit"]').attr('disabled', 'disabled').find('.far').removeClass('fa-long-arrow-right').addClass('fa-sync fa-spin');
            $('.has-error', $target).removeClass('has-error');
            $(':input', $target).tooltip('dispose');

            // AJAX
            $.ajax({
                url: ajax_url,
                data: $target.serialize() + '&security=' + ajax_nonce,
                dataType: 'json',
                type: 'post',
                async: true,
                cache: false,
                context: $target
            }).done(function(data, textStatus, jqXHR){
                if(data.success){
                    $target.closest('.modal').modal('hide');
                    $target.trigger('reset');
                    window.Page.showModal('message', { title: data.data.title, message: data.data.message });
                    //Page.sendEvent('contact', 'inquiry', 'successful');
                } else {
                    //Page.sendEvent('contact', 'inquiry', 'failed');
                }
            }).fail(function(jqXHR, textStatus, errorThrown){
                if(typeof jqXHR.responseJSON.data === 'object' && typeof jqXHR.responseJSON.data.messages === 'object' && jqXHR.responseJSON.data.messages.length){
                    var messages = jqXHR.responseJSON.data.messages;
                    $.each(messages, function(i, item){
                        if(typeof item === 'object' && item.field && item.message){
                            window.Page.showTooltip($(':input[name="' + item.field + '"]', $target), { title: item.message, placement: 'top', customClass: 'has-error' });
                            $(':input[name="' + item.field + '"]', $target).closest('.form-group').addClass('has-error');
                        }
                    });
                }
                //Page.sendEvent('contact', 'inquiry', 'failed');
            }).always(function(){
                $target.find('button[type="submit"]').removeAttr('disabled').find('.far').addClass('fa-long-arrow-right').removeClass('fa-sync fa-spin');
            });
        },

//------------------------------------------------------------------------------------------------------------------------
    // (5) scrollTo

        // Sticky menu
        stickyHeader: function(){
            // Szoveges aloldalkon mindig sticky a header
            if($('body').hasClass('subpage') || $('body').hasClass('our-moments')) return false;

            var checkpoint = $('.background', 'header').height() - $('nav.navbar').outerHeight();
            var opacity = 1;

            // Sticky menu
            if($(window).scrollTop() > checkpoint){
                $('header').addClass('sticky');
            }
            else {
                $('header').removeClass('sticky');
            }

            // Fooldali eltuno logo
            if($('body').hasClass('index')){
                if($(window).scrollTop() > (checkpoint / 3 * 2)){
                    if(!$('.navbar-brand', 'header').hasClass('fading-in')){
                        $('.navbar-brand', 'header').addClass('fading-in').removeClass('fading-out').stop().fadeIn(window.Page.animation);
                    }
                }
                else {
                    if(!$('.navbar-brand', 'header').hasClass('fading-out')){
                        $('.navbar-brand', 'header').addClass('fading-out').removeClass('fading-in').stop().fadeOut(window.Page.animation);
                    }
                }
            }

            // Eltuno hero szoveg
            if($(window).scrollTop() > (checkpoint / 3)){
                opacity = 1 - (($(window).scrollTop() - checkpoint / 3) / checkpoint * 3 / 2);
                if(opacity < 0) opacity = 0;
                if(opacity > 1) opacity = 1;
            }
            $('.hero, .hero-mobile', 'header').css({ opacity: opacity, filter: 'blur(' + (10 * (1 - opacity)) + 'px)' });
        },

        // scrollTo inicializalasa
        loadScrollTo: function(){
            // CTA
            $(document).on('click', 'a[href^="#"], a[href^="' + window.location.href + '#"]', function(e){
                e.preventDefault();
                window.Page.scrollToHash(this.hash);
            });

            // On load
            $(window).on('load', function(e){
                var hash = window.location.hash;
                if(/^\#[0-9a-z_-]+$/gi.test(hash) && $(hash).is(':visible')){
                    window.Page.scrollToHash(hash);
                }
            });
        },

        // Megfelelo tartalomhoz scrollozas
        scrollToHash: function(hash, params){
            if(!$(hash).is(':visible')) return false;

            // Beallitasok felulbiralasa
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.scrollTo, params);

            // Offset
            var navHeight = parseFloat($('nav.navbar').outerHeight());
            settings.offset.top = -navHeight;

            // Megfelelo tartalomhoz scrollozas
            $(window).scrollTo(hash, settings);
            window.location.hash = hash;

            // Menu becsukasa
            $('.navbar-collapse').collapse('hide');
        },

//------------------------------------------------------------------------------------------------------------------------
    // (6) Galeriak inicializalasa

        // Galeriak inicializalasa
        loadGalleries: function(){
            // CTA
            $(document).on('click', '.gallery', function(e){
                e.preventDefault();
                window.Page.openGallery($(this));
            });
        },

        // Galeria megnyitasa
        openGallery: function($target, params){
            // Beallitasok felulbiralasa
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.lightGallery, params);

            // Galeria adatai
            settings.dynamicEl = $target.data('gallery');

            // Galeria megnyitasa
            $target.lightGallery(settings);
        },

//------------------------------------------------------------------------------------------------------------------------
    // (7) GTM Event

        // GTM inicializalasa
        loadGTM: function(){
            // CTA
            $(document).on('click', '[data-event="click"]', function(e){
                window.Page.sendEvent($(this).data('event-action'), $(this).data('event-category'), $(this).data('event-label'));
            });

            // On load
            $('[data-event="callback"]').each(function(i, target){
                window.Page.sendEvent($(target).data('event-action'), $(target).data('event-category'), $(target).data('event-label'));
            });
        },

        // GTM Event
        sendEvent: function(action, category, label){
            window.Page.dataLayer.push({
                event: action,
                eventAction: action,
                eventCategory: category,
                eventLabel: label
            });
        },

//------------------------------------------------------------------------------------------------------------------------
    // (8) Cookie kezeles

        // Cookie consent
        setCookieConsent: function(){
            // Beallitasok felulbiralasa
            var params = { content: {} };
            if($('footer').data('cookie-message')) params.content.message = $('footer').data('cookie-message');
            if($('footer').data('cookie-button')) params.content.dismiss = $('footer').data('cookie-button');
            if($('footer').data('cookie-more')) params.content.link = $('footer').data('cookie-more');
            if($('footer').data('cookie-link')) params.content.href = $('footer').data('cookie-link');
            var settings = $.extend(true, {}, window.Page.cookie, params);

            // Inicializalas
            window.cookieconsent.initialise(settings);
        },

//------------------------------------------------------------------------------------------------------------------------
    // (9) Modalok megjelenitese

        // Modalok inicializalasa
        loadModals: function(){
            // Default modalok megnyitasa
            $('.modal[data-show="true"]').each(function(i, target){
                $(target).modal();
            });

            // Modal bezarasa
            $(document).on('hidden.bs.modal', '.modal', function(e){
                // Bootstrap bugfix: uj modal megnyitasa modalbol elveszti a gorgetest, ha a regit egyben be is zarjuk dismiss-szel
                if($('.modal.show').length) $('body').addClass('modal-open');
            });

            // Modal megnyitasa
            $(document).on('shown.bs.modal', '.modal', function(e){
                // Bootstrap bugfix: modal megnyitasanal nem ervenyesul az autofocus
                $(':input[autofocus]:first', $(this)).focus();
                // Megosztas linkjenek kijelolese
                if($(':input.auto-select', $(this)).length){
                    var link = $(e.relatedTarget).attr('href');
                    $(':input.auto-select', $(this)).val(link).select();
                }
            });
        },

        // Modal megjelenitese
        showModal: function(id, params){
            // Beallitasok felulbiralasa
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.modal, params);
            if(!id) return false;

            // Modal kivalasztasa
            var $modal = $('#modal-' + id);
            if(!$modal.length) return false;

            // Ertekek behelyettesitese
            if(params !== false){
                $('.modal-title', $modal).html(settings.title ? settings.title : '');
                $('.modal-body', $modal).html(settings.message ? '<p>' + settings.message + '</p>' : '');
            }

            // Modal megjelenitese
            $modal.modal();
        },

        // Hibauzenet modal
        showError: function(message){
            window.Page.showModal('error', { title: 'An error occured.', message: message });
        },

//------------------------------------------------------------------------------------------------------------------------
    // (10) Tooltipek megjelenitese

        // Tooltipek inicializalasa
        loadTooltips: function($container){
            // Tooltipek inicializalasa
            $('[data-toggle="tooltip"]', $container).each(function(i, target){
                var params = {};
                if($(target).data('tooltip-class')){
                    params.customClass = $(target).data('tooltip-class');
                }
                window.Page.showTooltip($(target), params);
            });
        },

        // Tooltip megjelenitese
        showTooltip: function($target, params){
            // Beallitasok felulbiralasa
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.tooltip, params);

            // Modal megjelenitese
            $target.tooltip(settings);
        },

    };

//------------------------------------------------------------------------------------------------------------------------
    // (11) Document ready

    // Document ready
    $(function(){
        // Kapcsolat urlapok inicializalasa
        window.Page.loadForms();

        // scrollTo inicializalasa
        window.Page.loadScrollTo();

        // Galeriak inicializalasa
        window.Page.loadGalleries();

        // Modalok inicializalasa
        window.Page.loadModals();

        // GTM inicializalasa
        window.Page.loadGTM();

        // Layout atmeretezese
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
    // (12) Oldal betoltese

    // Oldal betoltese
    $(window).on('load', function(e){
        // Layout atmeretezese
        window.Page.resizeLayout();
        // Cookie
        window.Page.setCookieConsent();
    });

//------------------------------------------------------------------------------------------------------------------------
    // (13) Oldal atmeretezese vagy nezet valtasa

    // Oldal atmeretezese vagy nezet valtasa
    $(window).on('orientationchange resize', function(e){
        // Layout atmeretezese
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
    // (14) Oldal gorgetese

    // Oldal gorgetese
    $(window).on('scroll', function(e){
        // Layout atmeretezese
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
})(jQuery);
